var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","flat":"","color":"transparent"}},[_c('v-toolbar-title',{staticClass:"font-weight-light d-none d-md-block"},[_vm._v(_vm._s(_vm.siteTitle))]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }